import { Component, Input } from '@angular/core'
import { UserService } from '@service/user/user.service'
import { DialogService } from '@service/dialog.service'

@Component({
  selector: 'app-full-width-image',
  templateUrl: './full-width-image.component.html',
  styleUrls: ['./full-width-image.component.scss']
})
export class FullWidthImageComponent {

  @Input() public image: string

  @Input() public buttontext: string = null

  constructor(
    public userService: UserService,
    public DialogService: DialogService
  ) { }

  public click() {
    if (!this.userService.isLoggedIn)
      this.DialogService.loginRegistrationDialog()
  }

}
